import React from 'react'

import { MobXProviderContext, observer } from 'mobx-react'

import DesktopInitialState from '~/client/src/desktop/stores/DesktopInitialState'
import ProjectSetupResourceForms from '~/client/src/desktop/views/ProjectSetUp/components/ProjectSetupResourceConfig/ResourceForms/ProjectSetupResourceForms'
import { ResourceTypeId } from '~/client/src/shared/constants/resourceTypes'
import { LocalStorageKey } from '~/client/src/shared/enums/LocalStorageKey'
import { useLocationResourceStore } from '~/client/src/shared/hooks/useLocationResourceStore'

function LocationsForms(): React.ReactElement {
  const { state } = React.useContext(MobXProviderContext) as {
    state: DesktopInitialState
  }
  const { schema } = useLocationResourceStore(state.activeProject?.id)

  return (
    <ProjectSetupResourceForms
      resourceTypeId={ResourceTypeId.LOCATIONS}
      columnConfigKey={LocalStorageKey.LocationsFormsColumnConfig}
      resourceSchema={schema}
    />
  )
}

export default observer(LocationsForms)
